import { browserdetect } from "./util/browserdetect";

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import router from "./router";
import VueAnalytics from "vue-analytics";
import VueVideoPlayer from "vue-video-player";

import "video.js/dist/video-js.css";

import "vueperslides/dist/vueperslides.css";

//import App from "./App";
import store from "./store";

var browser_is_allowed = browserdetect.init();
console.log("browser:", browserdetect.browser);
if (browser_is_allowed) {
  let is_mobile = browserdetect.isMobile();
  if (store.state.site_config.fake_mobile) is_mobile = true;

  store.dispatch("set_browser_identity", browserdetect.browser);
  store.dispatch("set_simple_val", {
    name: "browser_is_mobile",
    val: is_mobile
  });

  var App = require("./App").default;

  var VueTailwind = require("vue-tailwind");

  Vue.use(VueVideoPlayer, {
    options: {
      autoplay: true,
      muted: false,
      controls: true,
      language: "en",
      controlBar: {
        fullscreenToggle: false,
        volumeMenuButton: false,
        volumeControl: false,
        responsive: true,
        fluid: true,
        aspectRatio: "16:9"
      }
    }
  });

  //css famework
  Vue.use(VueTailwind);
  Vue.use(VueAnalytics, {
    id: __GA_UA_CODE__,
    debug: {
      enabled: __GA_DEBUG__,
      trace: __GA_DEBUG_TRACE__,
      sendHitTask: __GA_DEBUG_SEND_HITS__
    },
    commands: {
      trackExternalLink(href) {
        this.$ga.event(this.eventTag + "-external-link", "click", href);
      }
    }
  });

  Vue.config.productionTip = false;

  //global event bus, to make it easy to send commands
  //between components
  var bus = new Vue();
  Vue.prototype.$bus = bus;

  /* eslint-disable no-new */
  new Vue({
    el: "#app",
    router,
    store,
    components: { App },
    template: "<App/>"
  });

  //Unity sends JS calls to the window scope, so we create this outside vue
  //TODO: is there a better place to put this?
  window.getStr = function (cat, msg) {
    console.log("got message from unity", msg, cat);
    switch (cat) {
      case "toggle_status":
        var unity_info = msg.toLowerCase() == "true" ? "1" : "0";
        store.dispatch("set_unity_info", unity_info);
        break;
      case "on_app_started":
        store.dispatch("set_app_state", 0);

        break;
      case "on_transition_started":
        // store.dispatch('set_video_popup', msg.toLowerCase());

        bus.$emit("on-transition-started", msg.toLowerCase());
        break;
      case "on_transition_ended":
        bus.$emit("on-transition-ended", msg.toLowerCase());
        break;
      case "on_section_anim_ended":
        bus.$emit("on-section-anim-ended", msg.toLowerCase());
        break;
      case "area_btn":
        bus.$emit("on-area-btn-click", msg.toLowerCase());
        break;
    }
  };
}



// WEBPACK FOOTER //
// ./src/main.js